<template>
  <div
    class="events-menu"
    :style="{
      background: backgroundColor,
    }"
  >
    <div class="events-title">{{ t('Current Plan') }}</div>
    <div class="events-plan">
      {{ store.billing.planName }}
      ${{ formatPlanPrice(store.billing.planPrice) }}
    </div>
    <div class="events-menu__usage">
      <div class="events-menu__usage-header">
        <div class="event-usage">{{ t('Event Usage') }}</div>
        <ui-icon class="event-usage-icon" size="12" :icon="icon" :color="stateColor" />
      </div>
      <div class="progress-wrp">
        <div
          class="progress-active"
          :style="{
            width: eventsUsagePercent + '%',
            backgroundColor: stateColor,
          }"
        ></div>
      </div>
      <div class="events-menu__usage-footer">
        <div class="usage-data">{{ formatCount(store.billing.eventsUsed) }}</div>
        <div class="usage-data usage-data-right">
          {{ formatCount(store.billing.eventsIncluded) }}
        </div>
      </div>
    </div>
    <ui-button
      button-style="outline-accent"
      class="mt-12"
      :text="t('Change Plan')"
      icon="fas fa-exchange-alt"
      @click="openChangePlan"
    />
  </div>
</template>

<script setup lang="ts">
import numeral from 'numeral';
import { useI18n, useNavbarEvents } from '@/composables';
import { $emitter } from '@/services/emitter';
import { useStore } from '@/store';

const props = withDefaults(
  defineProps<{
    backgroundColor?: string;
    changePlanClick?: () => void;
  }>(),
  {
    backgroundColor: 'var(--color-mobile-menu-bg)',
  },
);

const store = useStore();
const { t } = useI18n();
const { eventsUsagePercent, stateColor, icon } = useNavbarEvents();

const formatPlanPrice = (price: number | undefined) =>
  numeral((price ?? 0) / 100).format('0,0[.]00');

const formatCount = (value: number | undefined) => numeral(value ?? 0).format('0,0');

const openChangePlan = () => {
  $emitter.emit('open-dialog', { name: 'ChangePlanDialog' });
  props.changePlanClick?.();
};
</script>

<style lang="scss" scoped>
.events-menu {
  padding: 16px;
  border-radius: inherit;
}

.events-title {
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  color: var(--color-charcoal);
}

.events-plan {
  font-size: 20px;
  color: var(--color-blue);
  margin-bottom: 18px;
}

.event-usage {
  font-size: 13px;
  color: var(--color-charcoal);
}

.events-menu__usage {
  width: 100%;
}

.events-menu__usage-header,
.events-menu__usage-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.events-menu__usage-footer {
  margin-top: 2px;
}

.event-usage-icon {
  flex-shrink: 0;
  line-height: 1;
}

.progress-wrp {
  background: var(--color-black10);
  border-radius: 2px;
  height: 4px;
  margin-top: 7px;
  margin-bottom: 2px;
  width: 100%;
}

.progress-active {
  border-radius: 2px;
  height: 4px;
  min-width: 3%;
  max-width: 100%;
}

.usage-data {
  font-size: 12px;
  line-height: 1;
  color: var(--color-charcoal);
}

.usage-data-right {
  text-align: right;
}

:deep(.v-menu__activator) {
  height: 100% !important;
}
</style>
